import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IAddWebClientNotificationsReducerState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IAddWebClientNotificationsReducerState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const addWebClientNotificationsSlice = createSlice({
  name: 'addWebClientNotifications',
  initialState,
  reducers: {
    changeAddWebClientNotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeAddWebClientNotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearAddWebClientNotifications() {
      return initialState;
    },
  },
});

export const {
  changeAddWebClientNotification,
  clearAddWebClientNotifications,
  changeAddWebClientNotificationAttrs,
} = addWebClientNotificationsSlice.actions;

export default addWebClientNotificationsSlice.reducer;
